{ "id": "amulette-bouftou", "name": "Amulette du Bouftou", "slot": "amulette", "set": "bouftou", "tier": 2, "price": 110, "icon": "icons/items/amulette-bouftou", "stats": { "vitalite": 15, "force": 15, "intelligence": 15 } }
